module.exports = __webpack_public_path__ + "static/media/28.bef1da4c.avif";